webpackJsonp([21],{

/***/ "xxdg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SubscriptionConfirmation", function() { return SubscriptionConfirmation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("vCxL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact__ = __webpack_require__("OmAK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("9qb7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__grubhubprod_cookbook_dist_cookbook_preact_esm_components_icon_icon__ = __webpack_require__("E1Iz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_shared_dependencies_nodash_get__ = __webpack_require__("qTro");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_shared_factories_appConfig_factory__ = __webpack_require__("woKH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_environment__ = __webpack_require__("evTo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_shared_meta_NoIndexHelmet__ = __webpack_require__("kNtN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_native_messages__ = __webpack_require__("Z564");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_components_PageLoader_PageLoader__ = __webpack_require__("Hn98");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_components_WebFooter__ = __webpack_require__("V0JC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_WebHeader__ = __webpack_require__("t5rp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_shared_utilities_screenWidth_utility__ = __webpack_require__("YsLK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_shared_utilities_localStorage_utility__ = __webpack_require__("pS93");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_SubscriptionBanner_SubscriptionBanner__ = __webpack_require__("vMeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utilities_subscriptions_utility__ = __webpack_require__("bFea");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Adapters_createAdapter__ = __webpack_require__("60Vk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__di_types__ = __webpack_require__("4WiR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__di__ = __webpack_require__("Ncjs");



















var SubscriptionConfirmation = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __extends */])(SubscriptionConfirmation, _super);
    function SubscriptionConfirmation() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.appConfig = Object(__WEBPACK_IMPORTED_MODULE_5_src_shared_factories_appConfig_factory__["a" /* appConfigFactory */])();
        _this.adapter = Object(__WEBPACK_IMPORTED_MODULE_16__Adapters_createAdapter__["a" /* createAdapter */])(_this.appConfig.platform, { history: _this.props.history });
        _this.storage = new __WEBPACK_IMPORTED_MODULE_13_src_shared_utilities_localStorage_utility__["a" /* LocalStorageUtility */]();
        return _this;
    }
    SubscriptionConfirmation.prototype.componentDidMount = function () {
        var _a;
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var subscription, brazeNewUserSignedUp;
            return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __generator */])(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        Object(__WEBPACK_IMPORTED_MODULE_15__utilities_subscriptions_utility__["u" /* setEndOfFlowDestination */])();
                        return [4 /*yield*/, this.getSubscription()];
                    case 1:
                        subscription = _b.sent();
                        this.setState({
                            subscription: subscription,
                        });
                        // we have redirected. As a result no need to continue the mounting and abort.
                        if (this.isRedirectNeeded()) {
                            return [2 /*return*/];
                        }
                        this.fireClickstreamPostPurchaseEvents(this.getQueryParams());
                        this.analytics.logPageView('subscription order confirmation', subscription, null, (_a = subscription) === null || _a === void 0 ? void 0 : _a.subscription_id);
                        this.nativeBridge.toNative(__WEBPACK_IMPORTED_MODULE_8_src_native_messages__["a" /* NativeMessages */].SUBSCRIPTION_PURCHASE_SUCCESS);
                        brazeNewUserSignedUp = this.storage.get('brazeNewUserSignedUp');
                        if (brazeNewUserSignedUp) {
                            this.analytics.logBrazeEvent(brazeNewUserSignedUp);
                            this.storage.remove('brazeNewUserSignedUp');
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Fire clickstream purchase events that are cutoff from the tonkotsu hosted /plus/purchase page. Then replaces state to wipe query params
     * @param searchParams url query param object. We check for sendClickstreamPurchaseEvent or sendClickstreamAutoOptInEvent and send clickstream event based on those params
     */
    SubscriptionConfirmation.prototype.fireClickstreamPostPurchaseEvents = function (searchParams) {
        var subscription = this.state.subscription;
        var history = this.props.history;
        var purchaseEvent = searchParams.get('sendClickstreamPurchaseEvent');
        if (purchaseEvent) {
            this.analytics.logSubscriptionPostPurchaseSuccessClickstream(subscription);
        }
        var autoOptInEvent = searchParams.get('sendClickstreamAutoOptInEvent');
        if (autoOptInEvent) {
            this.analytics.logSubscriptionPostAutoOptInSuccessClickstream(subscription);
        }
        history.replace("/plus/confirmation" /* CONFIRMATION */);
    };
    /**
     * Get query params from url
     */
    SubscriptionConfirmation.prototype.getQueryParams = function () {
        var location = this.props.location;
        return new URLSearchParams(location.search);
    };
    SubscriptionConfirmation.prototype.isRedirectNeeded = function () {
        var _a = this.props, credentialsReceived = _a.credentialsReceived, isAnonymous = _a.isAnonymous;
        if (credentialsReceived && isAnonymous) {
            this.adapter.redirectToSubscriptionInfo();
            return true;
        }
        return false;
    };
    SubscriptionConfirmation.prototype.getSubscription = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var subscription, e_1;
            return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.subscriptionService.getActiveSubscription()];
                    case 1:
                        subscription = (_a.sent()).subscription;
                        return [2 /*return*/, subscription];
                    case 2:
                        e_1 = _a.sent();
                        return [2 /*return*/, null];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    SubscriptionConfirmation.prototype.render = function () {
        var _a = this.props, credentialsReceived = _a.credentialsReceived, isAnonymous = _a.isAnonymous;
        var subscription = this.state.subscription;
        if (!subscription) {
            return Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(__WEBPACK_IMPORTED_MODULE_9_src_components_PageLoader_PageLoader__["a" /* PageLoader */], null);
        }
        var headerData = Object(__WEBPACK_IMPORTED_MODULE_15__utilities_subscriptions_utility__["e" /* getFormattedSubscriptionData */])(subscription);
        var isWeb = this.appConfig.platform === __WEBPACK_IMPORTED_MODULE_6_src_environment__["d" /* Platform */].WEB;
        return (Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])("div", null,
            Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(__WEBPACK_IMPORTED_MODULE_7_src_shared_meta_NoIndexHelmet__["a" /* NoIndexHelmet */], null),
            !credentialsReceived || isAnonymous || !subscription ? (Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(__WEBPACK_IMPORTED_MODULE_9_src_components_PageLoader_PageLoader__["a" /* PageLoader */], null)) : (Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])("div", null,
                isWeb && (Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])("nav", { class: "mainNav" /*Necessary in conjunction with outerWrapper below*/ }, Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(__WEBPACK_IMPORTED_MODULE_11_src_components_WebHeader__["a" /* WebHeader */], { signInRedirectUrl: "/plus/confirmation" /* CONFIRMATION */, isAuthenticated: credentialsReceived && !isAnonymous }))),
                Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])("section", { className: "outerWrapper", "at-subscription-confirmation": true },
                    Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(__WEBPACK_IMPORTED_MODULE_14__components_SubscriptionBanner_SubscriptionBanner__["a" /* SubscriptionBanner */], null),
                    Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])("div", { className: "u-inset-4 s-container-sm" },
                        Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])("div", { className: "u-stack-y-8 u-flex-center-center" },
                            Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])("div", { className: "subscription-confirmation-checkmark " },
                                Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__grubhubprod_cookbook_dist_cookbook_preact_esm_components_icon_icon__["a" /* Icon */], { icon: "check", size: "xl" }))),
                        Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])("div", { className: "u-stack-y-6" },
                            Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])("h2", { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('u-text-center', {
                                    'massive-heading': Object(__WEBPACK_IMPORTED_MODULE_12_src_shared_utilities_screenWidth_utility__["c" /* isMobileViewport */])(window),
                                }) }, Object(__WEBPACK_IMPORTED_MODULE_4_src_shared_dependencies_nodash_get__["a" /* get */])(subscription, 'texts.confirmation_page.title_text'))),
                        Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])("div", { className: "u-stack-y-8 u-line-bottom u-line--light" },
                            Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])("p", { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()({
                                    'u-stack-y-6': !Object(__WEBPACK_IMPORTED_MODULE_12_src_shared_utilities_screenWidth_utility__["c" /* isMobileViewport */])(window),
                                    'u-stack-y-8': Object(__WEBPACK_IMPORTED_MODULE_12_src_shared_utilities_screenWidth_utility__["c" /* isMobileViewport */])(window),
                                }) }, Object(__WEBPACK_IMPORTED_MODULE_4_src_shared_dependencies_nodash_get__["a" /* get */])(subscription, 'texts.confirmation_page.body_text'))),
                        Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])("div", { className: "u-stack-y-8" }, Object.keys(headerData.bullets).map(function (bullet, index) {
                            var _a = headerData.bullets[bullet], text = _a.text, image_url = _a.image_url;
                            if (text === '' || image_url === '') {
                                return null;
                            }
                            return (Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])("div", { className: "u-flex u-flex-align-xs--center u-stack-y-4", key: index },
                                Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])("img", { className: "u-stack-x-4 cb-icon--lg", src: image_url, alt: "membership benefit icon" }),
                                Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])("span", { className: "lead" }, text)));
                        })),
                        Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])("div", { className: "u-stack-y-12" },
                            Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])("button", { "at-subscription-confirmation-cta": true, class: "s-btn s-btn--large s-btn-primary s-btn--block", onClick: this.adapter.onFlowComplete }, Object(__WEBPACK_IMPORTED_MODULE_4_src_shared_dependencies_nodash_get__["a" /* get */])(subscription, 'texts.confirmation_page.cta_text')))),
                    isWeb && (Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])("footer", null,
                        Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(__WEBPACK_IMPORTED_MODULE_10_src_components_WebFooter__["a" /* WebFooter */], null))))))));
    };
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __decorate */])([
        Object(__WEBPACK_IMPORTED_MODULE_18__di__["a" /* lazyInject */])(__WEBPACK_IMPORTED_MODULE_17__di_types__["a" /* TYPES */].SubscriptionAnalytics),
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __metadata */])("design:type", Object)
    ], SubscriptionConfirmation.prototype, "analytics", void 0);
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __decorate */])([
        Object(__WEBPACK_IMPORTED_MODULE_18__di__["a" /* lazyInject */])(__WEBPACK_IMPORTED_MODULE_17__di_types__["a" /* TYPES */].SubscriptionService),
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __metadata */])("design:type", Object)
    ], SubscriptionConfirmation.prototype, "subscriptionService", void 0);
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __decorate */])([
        Object(__WEBPACK_IMPORTED_MODULE_18__di__["a" /* lazyInject */])(__WEBPACK_IMPORTED_MODULE_17__di_types__["a" /* TYPES */].NativeBridge),
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __metadata */])("design:type", Object)
    ], SubscriptionConfirmation.prototype, "nativeBridge", void 0);
    return SubscriptionConfirmation;
}(__WEBPACK_IMPORTED_MODULE_1_preact__["Component"]));



/***/ })

});


// WEBPACK FOOTER //
// 21.chunk.df8d5.js